var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useRef, useMemo, useEffect, } from 'react';
import { LottieSlide } from '../slides/LottieSlide';
import headline from '../../assets/images/scroll-locked-slider/Headline.webp';
import carousel1 from '../../assets/images/scroll-locked-slider/Carousel1.webp';
import carousel2 from '../../assets/images/scroll-locked-slider/Carousel2.webp';
import carousel3 from '../../assets/images/scroll-locked-slider/Carousel3.webp';
import headlineMobile from '../../assets/images/scroll-locked-slider/HeadlineMobile.webp';
import carouselMobile1 from '../../assets/images/scroll-locked-slider/CarouselMobile1.webp';
import carouselMobile2 from '../../assets/images/scroll-locked-slider/CarouselMobile2.webp';
import carouselMobile3 from '../../assets/images/scroll-locked-slider/CarouselMobile3.webp';
import backgroundImageGradient from '../../assets/images/scroll-locked-slider/BackgroundImage.svg';
import backgroundImageMobileGradient from '../../assets/images/scroll-locked-slider/BackgroundImageMobile.webp';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);
import '../slides/Slides.scss';
import { useOnScreen } from '../../hooks/useOnScreen';
import useViewport from '../../hooks/useViewport';
export var allSlides = [
    {
        slide: 0,
        isLottieSlide: true,
        lottiePathDesktop: 'https://assets6.lottiefiles.com/private_files/lf30_nshmb1el.json',
        lottiePathMobile: 'https://assets1.lottiefiles.com/private_files/lf30_mfpnz3mw.json',
    },
    {
        slide: 1,
        richText: '<h2>But each client has<br />\r\n<strong>two disconnected financial lives</strong></h2>\r\n',
        richText2: '',
        textHexColor: '#005f9e',
        backgroudHexColor: '#ffffff',
        backgroundImageDesktop: '',
        backgroundImageMobile: '',
        hasArrows: false,
        isTwoColumnLayout: false,
    },
    {
        slide: 2,
        richText: '<h2>But each client has<br />\r\n<strong>two disconnected financial lives</strong></h2>\r\n',
        richText2: '',
        textHexColor: '#ffffff',
        backgroudHexColor: '#005f9e',
        backgroundImageDesktop: '',
        backgroundImageMobile: '',
        hasArrows: false,
        isTwoColumnLayout: false,
    },
    {
        slide: 3,
        richText: '<h3 class="text-align-center"><strong>There are daily finances</strong></h3>\r\n<ul class="text-align-center">\r\n<li>Credit cards</li>\r\n<li>Income</li>\r\n<li>Bills</li>\r\n<li>Taxes</li>\r\n<li>Loans</li>\r\n</ul>\r\n',
        richText2: '',
        textHexColor: '#ffffff',
        backgroudHexColor: '#005f9e',
        backgroundImageDesktop: backgroundImageGradient,
        backgroundImageMobile: backgroundImageMobileGradient,
        hasArrows: false,
        isTwoColumnLayout: true,
    },
    {
        slide: 4,
        richText: '<h3 class="text-align-center"><strong>There are daily finances</strong></h3>\r\n<ul class="text-align-center">\r\n<li>Credit cards</li>\r\n<li>Income</li>\r\n<li>Bills</li>\r\n<li>Taxes</li>\r\n<li>Loans</li>\r\n</ul>\r\n',
        richText2: '<h3 class="text-align-center"><strong>And long-term goals</strong></h3>\r\n<ul class="text-align-center">\r\n<li>Investments</li>\r\n<li>Mortage</li>\r\n<li>Tuition</li>\r\n<li>401(k)s</li>\r\n<li>Savings</li>\r\n</ul>\r\n',
        textHexColor: '#ffffff',
        backgroudHexColor: '#0074bd',
        backgroundImageDesktop: backgroundImageGradient,
        backgroundImageMobile: backgroundImageMobileGradient,
        hasArrows: false,
        isTwoColumnLayout: true,
    },
    {
        slide: 5,
        richText: '',
        richText2: '',
        textHexColor: '#ffffff',
        backgroudHexColor: '',
        backgroundImageDesktop: backgroundImageGradient,
        backgroundImageMobile: backgroundImageMobileGradient,
        hasArrows: false,
        isTwoColumnLayout: false,
    },
    {
        slide: 6,
        richText: '<h2>With no bridge between the two, financial decisions are less impactful</h2>\r\n',
        richText2: '',
        textHexColor: '#ffffff',
        backgroudHexColor: '',
        backgroundImageDesktop: backgroundImageGradient,
        backgroundImageMobile: backgroundImageMobileGradient,
        hasArrows: false,
        isTwoColumnLayout: false,
    },
    {
        slide: 7,
        richText: '',
        textHexColor: '#ffffff',
        richText2: '',
        backgroudHexColor: null,
        backgroundImageDesktop: headline,
        backgroundImageMobile: headlineMobile,
        hasArrows: false,
        isTwoColumnLayout: false,
    },
    {
        slide: 8,
        richText: '<h2>Envestnet is powering a different future</h2>\r\n',
        textHexColor: '#ffffff',
        richText2: '',
        backgroudHexColor: null,
        backgroundImageDesktop: headline,
        backgroundImageMobile: headlineMobile,
        hasArrows: false,
        isTwoColumnLayout: false,
    },
    {
        slide: 9,
        richText: '<p>A future where every facet of your clients’ finances are visible and working together</p>\r\n',
        richText2: '',
        textHexColor: '#ffffff',
        backgroudHexColor: null,
        backgroundImageDesktop: carousel1,
        backgroundImageMobile: carouselMobile1,
        hasArrows: true,
    },
    {
        slide: 10,
        richText: '<p>A future where there’s a seamless flow between the things they spend money on now and the investments they make for later</p>\r\n',
        richText2: '',
        textHexColor: '#ffffff',
        backgroudHexColor: null,
        backgroundImageDesktop: carousel2,
        backgroundImageMobile: carouselMobile2,
        hasArrows: true,
    },
    {
        slide: 11,
        richText: '<p>A future where the financial services industry innovates together via an open platform, allowing advisors to reach more clients, with more impact</p>\r\n',
        richText2: '',
        textHexColor: '#ffffff',
        backgroudHexColor: null,
        backgroundImageDesktop: carousel3,
        backgroundImageMobile: carouselMobile3,
        hasArrows: true,
    },
];
export var arrowSlides = [
    {
        slide: 9,
        richText: '<p>A future where every facet of your clients’ finances are visible and working together</p>\r\n',
        richText2: '',
        textHexColor: '#ffffff',
        backgroudHexColor: null,
        backgroundImageDesktop: carousel1,
        backgroundImageMobile: carouselMobile1,
        hasArrows: true,
    },
    {
        slide: 10,
        richText: '<p>A future where there’s a seamless flow between the things they spend money on now and the investments they make for later</p>\r\n',
        richText2: '',
        textHexColor: '#ffffff',
        backgroudHexColor: null,
        backgroundImageDesktop: carousel2,
        backgroundImageMobile: carouselMobile2,
        hasArrows: true,
    },
    {
        slide: 11,
        richText: '<p>A future where the financial services industry innovates together via an open platform, allowing advisors to reach more clients, with more impact</p>\r\n',
        richText2: '',
        textHexColor: '#ffffff',
        backgroudHexColor: null,
        backgroundImageDesktop: carousel3,
        backgroundImageMobile: carouselMobile3,
        hasArrows: true,
    },
];
export var lottieSlides = [
    {
        slide: 0,
        isLottieSlide: true,
        lottiePathDesktop: 'https://assets1.lottiefiles.com/private_files/lf30_zppf8kkq.json',
        lottiePathMobile: 'https://assets1.lottiefiles.com/private_files/lf30_fpyhahlw.json',
    },
];
export var sipleSlides = [
    {
        slide: 1,
        richText: '<h2>But each client has<br />\r\n<strong>two disconnected financial lives</strong></h2>\r\n',
        richText2: '',
        textHexColor: '#005f9e',
        backgroudHexColor: '#ffffff',
        backgroundImageDesktop: '',
        backgroundImageMobile: '',
        hasArrows: false,
        isTwoColumnLayout: false,
    },
    {
        slide: 2,
        richText: '<h2>But each client has<br />\r\n<strong>two disconnected financial lives</strong></h2>\r\n',
        richText2: '',
        textHexColor: '#ffffff',
        backgroudHexColor: '#005f9e',
        backgroundImageDesktop: '',
        backgroundImageMobile: '',
        hasArrows: false,
        isTwoColumnLayout: false,
    },
    {
        slide: 5,
        richText: '',
        richText2: '',
        textHexColor: '#ffffff',
        backgroudHexColor: '',
        backgroundImageDesktop: backgroundImageGradient,
        backgroundImageMobile: backgroundImageMobileGradient,
        hasArrows: false,
        isTwoColumnLayout: false,
    },
    {
        slide: 6,
        richText: '<h2>With no bridge between the two, financial decisions are less impactful</h2>\r\n',
        richText2: '',
        textHexColor: '#ffffff',
        backgroudHexColor: '',
        backgroundImageDesktop: backgroundImageGradient,
        backgroundImageMobile: backgroundImageMobileGradient,
        hasArrows: false,
        isTwoColumnLayout: false,
    },
    {
        slide: 7,
        richText: '',
        textHexColor: '#ffffff',
        richText2: '',
        backgroudHexColor: null,
        backgroundImageDesktop: headline,
        backgroundImageMobile: headlineMobile,
        hasArrows: false,
        isTwoColumnLayout: false,
    },
    {
        slide: 8,
        richText: '<h2>Envestnet is powering a different future</h2>\r\n',
        textHexColor: '#ffffff',
        richText2: '',
        backgroudHexColor: null,
        backgroundImageDesktop: headline,
        backgroundImageMobile: headlineMobile,
        hasArrows: false,
        isTwoColumnLayout: false,
    },
];
export var twoColumnsSlides = [
    {
        slide: 3,
        richText: '<h3 class="text-align-center"><strong>There are daily finances</strong></h3>\r\n<ul class="text-align-center">\r\n<li>Credit cards</li>\r\n<li>Income</li>\r\n<li>Bills</li>\r\n<li>Taxes</li>\r\n<li>Loans</li>\r\n</ul>\r\n',
        richText2: '',
        textHexColor: '#ffffff',
        backgroudHexColor: '#005f9e',
        backgroundImageDesktop: backgroundImageGradient,
        backgroundImageMobile: backgroundImageMobileGradient,
        hasArrows: false,
        isTwoColumnLayout: true,
    },
    {
        slide: 4,
        richText: '<h3 class="text-align-center"><strong>There are daily finances</strong></h3>\r\n<ul class="text-align-center">\r\n<li>Credit cards</li>\r\n<li>Income</li>\r\n<li>Bills</li>\r\n<li>Taxes</li>\r\n<li>Loans</li>\r\n</ul>\r\n',
        richText2: '<h3 class="text-align-center"><strong>And long-term goals</strong></h3>\r\n<ul class="text-align-center">\r\n<li>Investments</li>\r\n<li>Mortage</li>\r\n<li>Tuition</li>\r\n<li>401(k)s</li>\r\n<li>Savings</li>\r\n</ul>\r\n',
        textHexColor: '#ffffff',
        backgroudHexColor: '#0074bd',
        backgroundImageDesktop: backgroundImageGradient,
        backgroundImageMobile: backgroundImageMobileGradient,
        hasArrows: false,
        isTwoColumnLayout: true,
    },
];
export var data = __spreadArray(__spreadArray([], lottieSlides), arrowSlides);
var defaultProps = { data: data };
export var ScrollLockedLottieSlider = function (_a) {
    var className = _a.className, data = _a.data, pagination = _a.pagination;
    var scrollLockedSliderRef = useRef(null);
    var isOnScreen = useOnScreen(scrollLockedSliderRef, 0.75);
    var _b = useState(false), isLottieAnimationFinished = _b[0], setLottieAnimationStatus = _b[1];
    var _c = useState('snap-start'), snapClass = _c[0], setSnapClass = _c[1];
    var _d = useViewport(), visualViewport = _d.visualViewport, breakPoints = _d.breakPoints;
    var isMobile = useMemo(function () {
        return visualViewport.width <= breakPoints.tablet.width;
    }, [visualViewport]);
    useEffect(function () {
        // const snapScrollerElement = document.getElementById(
        //   'container-snap-scroller',
        // );
        var scrollTrigger = {
            trigger: scrollLockedSliderRef.current,
            start: 'center center',
            end: "+=5000",
            pin: '#scroll-lottie-pin-container',
            pinSpacing: true,
            scrub: true,
        };
        // if (snapScrollerElement) {
        //   scrollTrigger.scroller = `#container-snap-scroller`;
        //   let observerScrollerInstance: any = null;
        //   scrollTrigger.onEnter = () => {
        //     if (!observerScrollerInstance) {
        //       observerScrollerInstance = ScrollTrigger.normalizeScroll({
        //         target: `#container-snap-scroller`,
        //         id: 'starting',
        //         isEnabled: false,
        //       });
        //     }
        //   };
        //   scrollTrigger.onEnterBack = () => {
        //     if (!observerScrollerInstance) {
        //       observerScrollerInstance = ScrollTrigger.normalizeScroll({
        //         target: `#container-snap-scroller`,
        //         id: 'starting-again',
        //         isEnabled: false,
        //       });
        //     }
        //   };
        //   scrollTrigger.onLeave = () => {
        //     observerScrollerInstance?.kill();
        //     observerScrollerInstance = null;
        //   };
        //   scrollTrigger.onLeaveBack = () => {
        //     observerScrollerInstance?.kill();
        //     observerScrollerInstance = null;
        //   };
        // }
        gsap.timeline({
            scrollTrigger: __assign({}, scrollTrigger),
        });
    }, []);
    var sortedData = data.sort(function (_a, _b) {
        var slideA = _a.slide;
        var slideB = _b.slide;
        return slideA - slideB;
    });
    var _e = sortedData[0], slide = _e.slide, lottiePathDesktop = _e.lottiePathDesktop, lottiePathMobile = _e.lottiePathMobile;
    return (_jsx("div", __assign({ className: snapClass + " " + (className || '') + " lg:overflow-visible overflow-hidden", ref: scrollLockedSliderRef, id: "scroll-lottie-slider" }, { children: _jsx("div", __assign({ id: "scroll-lottie-pin-container" }, { children: _jsx(LottieSlide, { data: { slide: slide, lottiePathDesktop: lottiePathDesktop, lottiePathMobile: lottiePathMobile }, isOnScreen: isOnScreen, isScrubSlide: true, activeSlide: 0, setLottieAnimationStatus: setLottieAnimationStatus, autoplay: true, standalone: true }, "asdasd") }), void 0) }), void 0));
};
ScrollLockedLottieSlider.defaultProps = defaultProps;
